import React from "react";
import {
  Button,
  Col,
  Descriptions,
  List,
  Row,
  Space,
  Tooltip,
  Typography,
  Badge
} from "antd";

import Link from "../../../core/ui/components/Link";
import { FileWordOutlined } from "@ant-design/icons";
import { TCaseDecisionPresentationModel } from "../../presenter/model/CaseDecisionPresentationModel";

export interface CaseDecisionListItemProps {
  translate: any;
  item: TCaseDecisionPresentationModel;
  showCaseDecisionDetails: any;
}
const CaseDecisionListItem: React.FC<CaseDecisionListItemProps> = (
  props: CaseDecisionListItemProps
) => {
  const { translate, item, showCaseDecisionDetails } = props;
  return (
    <List.Item style={{ cursor: "pointer" }} className={"card-list-item"}>
      <Row className={"card-list-item-actions-top"}>
        <Col
          xs={24}
          sm={24}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Badge
            count={translate(
              `editors.case_decisions.status_values.${item.status}`
            )}
            className={"png-badge"}
          />
        </Col>
      </Row>
      <Link
        block
        type="text"
        onClick={() => showCaseDecisionDetails(item.id)}
        children={
          <Col>
            <Typography.Paragraph ellipsis={{ rows: 3 }} strong>
              {item.name}
            </Typography.Paragraph>
          </Col>
        }
      />
      <Row
        className={"card-list-item-decriptions"}
        onClick={() => showCaseDecisionDetails(item.id)}
      >
        <Col>
          <Descriptions size={"small"}>
            <Descriptions.Item
              style={{ width: "40%" }}
              label={
                <strong>
                  {translate("editors.case_decisions.organisation_name")}
                </strong>
              }
            >
              {item.organisationName}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ width: "40%" }}
              label={
                <strong>
                  {translate("editors.case_decisions.case_decision_type")}
                </strong>
              }
            >
              {item.caseDecisionType?.name}
            </Descriptions.Item>
            {/* <Descriptions.Item
              style={{ width: "20%" }}
              label={
                <strong>
                  {translate("editors.case_decisions.court_case_number")}
                </strong>
              }
            >
              {item.caseNumber}
            </Descriptions.Item> */}
          </Descriptions>
        </Col>
      </Row>
      <Row className={"card-list-item-actions-bottom"}>
        <Col>
          <Space size={"small"}>
            <Tooltip title="Preuzmite dokument">
              <Button type="link" icon={<FileWordOutlined />} shape="circle">
                Preuzmite dokument
              </Button>
            </Tooltip>
          </Space>
        </Col>
      </Row>
    </List.Item>
  );
};
export default CaseDecisionListItem;
